import { ApiService } from "@/api";

export const aggStatusOfGroupAll = () => {
  return ApiService.baseAction("agg/status/group", {}, "GET");
};
